export const getHeightOfHeader = () => {
  let box = document.querySelector("header")
  return box?.clientHeight as number
}
